import { useEffect, useState, useCallback } from 'react';
import { getDevicePlatform, isDownloadAvailable } from '../utils/helper-functions';
import posthog from 'posthog-js';
import pikkoLogo from '../styles/img/logo_pikko_native_app.jpeg';
import googlePlayBadge from '../styles/img/google_play_badge_fr.png';
import appStoreBadge from '../styles/img/app_store_badge_fr.svg';

const IOS_URL = process.env.REACT_APP_IOS_DOWNLOAD_URL;
const ANDROID_URL = process.env.REACT_APP_ANDROID_DOWNLOAD_URL;


const DownloadAppPopup = () => {
  const [visible, setVisible] = useState(false);
  const [shimmer, setShimmer] = useState(false);
  const [pulse, setPulse] = useState(false);
  const platform = getDevicePlatform();

  useEffect(() => {
    if (!isDownloadAvailable()) return;

    const timer = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(timer);
  }, []);

  // Shimmer every 2.8s
  useEffect(() => {
    if (!visible) return;
    const t = setInterval(() => setShimmer(true), 2800);
    return () => clearInterval(t);
  }, [visible]);

  useEffect(() => {
    if (shimmer) {
      const t = setTimeout(() => setShimmer(false), 900);
      return () => clearTimeout(t);
    }
  }, [shimmer]);

  // Pulse every 4s
  useEffect(() => {
    if (!visible) return;
    const t = setInterval(() => setPulse(true), 4000);
    return () => clearInterval(t);
  }, [visible]);

  useEffect(() => {
    if (pulse) {
      const t = setTimeout(() => setPulse(false), 600);
      return () => clearTimeout(t);
    }
  }, [pulse]);

  const handleStoreClick = useCallback((platform) => {
    const url = platform === 'ios' ? IOS_URL : ANDROID_URL;
    posthog.capture('popup_cta_clicked', { platform, store_url: url });
    window.open(url, '_blank');
  }, []);

  if (!isDownloadAvailable() || !visible) return null;

  return (
    <div
      className={'download-app-popup-wrapper tremble'}
      style={{
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(40px) scale(0.92)',
        opacity: visible ? 1 : 0,
      }}
    >
      {/* Shimmer overlay */}
      <div
        className="download-app-popup__shimmer"
        style={{
          transform: shimmer ? 'translateX(110%)' : 'translateX(-110%)',
          transition: shimmer ? 'transform 0.9s ease' : 'none',
        }}
      />

      {/* Decorative circles */}
      <div className="download-app-popup__circle download-app-popup__circle--top" />
      <div className="download-app-popup__circle download-app-popup__circle--bottom" />

      <div className="download-app-popup__body">
        {/* Badge */}
        <div className="download-app-popup__badge">
          <span
            className="download-app-popup__badge-dot"
            style={{
              boxShadow: pulse ? '0 0 8px 2px rgba(252,211,77,0.6)' : '0 0 0 0 transparent',
            }}
          />
          NOUVEAU
        </div>

        <div className="download-app-popup__row">
          {/* App icon + Text */}
          <img
            src={pikkoLogo}
            alt="PikkoPay"
            className="download-app-popup__app-icon"
            style={{
              transform: pulse ? 'scale(1.08) rotate(2deg)' : 'scale(1) rotate(0deg)',
            }}
          />

          <div className="download-app-popup__text-col">
            <div className="download-app-popup__title">
              Télécharge l'application
            </div>
            <div className="download-app-popup__subtitle">
              Scanne, paye et gagne du temps à chaque visite.
            </div>
          </div>
        </div>

        {/* Store button */}
        <div className="download-app-popup__stores">
          {!platform.isAndroid && (
            <img
              src={appStoreBadge}
              alt="Télécharger sur l'App Store"
              className="download-app-popup__store-badge"
              onClick={() => handleStoreClick('ios')}
              style={{ transform: pulse ? 'scale(1.03)' : 'scale(1)' }}
            />
          )}
          {!platform.isIOS && (
            <img
              src={googlePlayBadge}
              alt="Disponible sur Google Play"
              className="download-app-popup__store-badge"
              onClick={() => handleStoreClick('android')}
              style={{ transform: pulse ? 'scale(1.03)' : 'scale(1)' }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadAppPopup;
